// services/product.js
import apiClient from './api';

/**
 * Fetches a list of products from a Salesforce org (generic endpoint).
 * Corresponds to: GET /api/products/:orgId/salesforce
 */
export async function getSalesforceProducts(orgId, filters = null) {
  console.log('[getSalesforceProducts]', orgId, filters);
  const response = await apiClient.get(`/products/${orgId}/salesforce`, { data: { filters } });
  return response.data;
}

/**
 * Fetches all product versions stored in our database for the current tenant.
 * Corresponds to: GET /api/products/database/all
 */
export async function getAllProductsFromDb() {
  const response = await apiClient.get('/products/database/all');
  return response.data;
}

/**
 * Fetches specific product versions from our database for a given org.
 * Corresponds to: GET /api/products/:orgId/database
 */
export async function getProductsFromDb(orgId, products, isDeploy = false) {
  console.log('[getProductsFromDb]', orgId, products, isDeploy);

  const response = await apiClient.post(`/products/${orgId}/database`, {
    productIds: products,
    isDeploy,
  });
  return response.data;
}

/**
 * Fetches only the major versions of products from our database for a given org.
 * Corresponds to: GET /api/products/:orgId/database/major-versions
 */
export async function getMajorVersionsFromDb(orgId, products) {
  console.log('[getMajorVersionsFromDb]', orgId, products);

  const response = await apiClient.post(`/products/${orgId}/database/major-versions`, {
    productIds: products,
  });
  return response.data;
}

/**
 * Fetches ALL product versions (not just major X.0.0 versions) for patch selection.
 * This includes patch versions (X.X.1) and minor versions (X.1.0).
 * Corresponds to: POST /api/products/:orgId/database/all-versions-for-patch
 */
export async function getAllVersionsForPatch(orgId, products) {
  console.log('[getAllVersionsForPatch]', orgId, products);

  const response = await apiClient.post(`/products/${orgId}/database/all-versions-for-patch`, {
    productIds: products,
  });
  return response.data;
}

/**
 * Compares a Salesforce product object with a database product object.
 * Corresponds to: POST /api/products/compare
 */
export async function compareProducts(sfProduct, databaseProduct, isDeploy, orgId) {
  console.log('[compareProducts]', sfProduct, databaseProduct, isDeploy);

  const response = await apiClient.post('/products/compare', {
    sf_product: sfProduct,
    database_product: databaseProduct,
    isDeploy,
    org_id: orgId,
  });

  console.log('[compareProducts] response', response.data);

  return response.data;
}

export async function compareProductsBulk(sfProducts, databaseProducts, isDeploy, orgId) {
  const response = await apiClient.post('/products/compare-bulk', {
    sf_products: sfProducts,
    database_products: databaseProducts,
    isDeploy,
    org_id: orgId,
  });
  // The response will be { success: true, diffs: [ {diff:{...}}, {diff:{...}} ] }
  return response.data;
}

/**
 * Commits products fetched from Salesforce to our internal database.
 * Corresponds to: POST /api/products/:orgId/commit
 */
export async function commitProductsToDatabase(orgId, products) {
  const response = await apiClient.post(`/products/${orgId}/commit`, { products });

  return response.data;
}

/**
 * Deploys product configurations from our database to Salesforce.
 * Corresponds to: POST /api/products/:orgId/deploy
 */
export async function deployProducts(orgId, products) {
  const response = await apiClient.post(`/products/${orgId}/deploy`, { products });
  return response.data.response;
}

/**
 * Deletes a specific product version from the database and updates metadata.
 * Corresponds to: DELETE /api/products/:productId
 * @param {string} productId - The _id of the product version to delete.
 */
export async function deleteProduct(productId) {
  const response = await apiClient.delete(`/products/version/${productId}`);
  return response.data;
}
